import { useContextController } from "context";
import {
  AddSite,
  APITokens,
  Apple,
  Boxes,
  BoxLogs,
  Cameras,
  ConfirmationsPage,
  Dashboard,
  DismissalsPage,
  EditCameraRegion,
  ForgotPassword,
  Google,
  IncidentDetail,
  IncidentExportPage,
  IncidentsList,
  Integrations,
  Login,
  OTP,
  Password,
  Profile,
  Site,
  Sites,
  Threat,
  Threats,
  Users
} from "pages";
import FeatureFlags from "incidents/FeatureFlags";
import IncidentGate from "incidents/IncidentGate";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

export const Routing: React.FC<{}> = () => {
  const [{ userData }] = useContextController();

  return (
    <BrowserRouter>
      <FeatureFlags />
      <Routes>
        <Route path="/" element={userData ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/login" element={<Login />} />
        <Route path="/google" element={<Google />} />
        <Route path="/apple" element={<Apple />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="integrations/api-tokens" element={<APITokens />} />
        <Route path="/cameras" element={<Cameras />} />
        <Route path="/cameras/:cameraId" element={<EditCameraRegion />} />
        <Route path="/boxes" element={<Boxes />} />
        <Route path="/boxes/:id/logs" element={<BoxLogs />} />
        <Route path="/threats" element={<Threats />} />
        <Route path="/threats/:id" element={<Threat />} />
        <Route
          path="/incidents"
          element={
            <IncidentGate>
              <IncidentsList />
            </IncidentGate>
          }
        />
        <Route
          path="/incidents/confirmations"
          element={
            <IncidentGate>
              <ConfirmationsPage />
            </IncidentGate>
          }
        />
        <Route
          path="/incidents/reports/dismissals"
          element={
            <IncidentGate>
              <DismissalsPage />
            </IncidentGate>
          }
        />
        <Route
          path="/incidents/:id/export"
          element={
            <IncidentGate>
              <IncidentExportPage />
            </IncidentGate>
          }
        />
        <Route
          path="/incidents/:id"
          element={
            <IncidentGate>
              <IncidentDetail />
            </IncidentGate>
          }
        />
        {process.env.NODE_ENV === "development" ? (
          <>
            <Route path="/dev/incidents" element={<IncidentsList preview />} />
            <Route path="/dev/incidents/confirmations" element={<ConfirmationsPage preview />} />
            <Route path="/dev/incidents/reports/dismissals" element={<DismissalsPage preview />} />
            <Route path="/dev/incidents/:id/export" element={<IncidentExportPage preview />} />
            <Route path="/dev/incidents/:id" element={<IncidentDetail preview />} />
          </>
        ) : null}
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/add" element={<AddSite />} />
        <Route path="/sites/:id" element={<Site />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/otp" element={<OTP />} />
        <Route path="/forgot-password/password" element={<Password />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
